import { Empty, Flex } from 'antd';
import useInvoicesQuery from 'hooks/useInvoicesQuery';

import type { ComponentType } from 'react';
import type { Invoice } from './FarmerInvoice';

interface InvoiceListProps {
  params: Record<string, string>;
}

export const withInvoiceList = (
  WrappedComponent: ComponentType<{ invoice: Invoice }>,
) => {
  const EnhancedComponent = ({ params }: InvoiceListProps) => {
    const { data: invoices } = useInvoicesQuery({ params, enabled: true });

    return (
      <Flex gap={20} vertical className="invoice-list">
        {invoices?.map((invoice: Invoice) => (
          <WrappedComponent key={invoice?.invoiceId} invoice={invoice} />
        ))}
        {invoices?.length === 0 && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No invoices available yet"
          />
        )}
      </Flex>
    );
  };
  return EnhancedComponent;
};
